
var app = angular.module('easyj.progress', [
	'ngStorage'
]);

app.directive('bbProgress', function() {
	return {
		restrict: 'A',
		require: 'ngModel',
		scope: {
			ngModel: '&'
		},
		// template: '"Directive":{{ngModel()}}',
		templateUrl: 'app/components/progress/progress.html',
		controllerAs: 'prog',
		controller: function($scope, $routeParams, $timeout) {
			var prog = this;

			prog.cur = $scope.ngModel();
			prog.baseLink = '#/wizard/';

			prog.getClass = function(s, cur) {
				var out = 'disabled';
				if (cur > s){
					out = 'complete';
				} else if (cur === s) {
					out = 'active';
				} else {
					out = 'disabled';
				}
				if (s.toString() === $routeParams.step) {
					out += ' selected';
				}
				return out;
			};

			// it would be nice if we could extract this data from the steps directory
			prog.steps = [
				{
					desc: 'Drivetrain'
				},{
					desc: 'Motors'
				},{
					desc: 'Pneumatics'
				},{
					desc: 'Driver Station Inputs'
				},{
					desc: 'Digital Inputs'
				},{
					desc: 'Analog Inputs'
				},{
					desc: 'Subsystems'
				},{
					desc: 'Acutator & Sensor Assiginment'
				},{
					desc: 'Action Code'
				},{
					desc: 'Commands'
				},{
					desc: 'Command Code'
				},{
					desc: 'Operator Interface (OI)'
				},{
					desc: 'Autonomous'
				},{
					desc: 'Export'
				}
			];
			for (var i = 0; i < prog.steps.length; i++) {
				prog.steps[i].class = prog.getClass(i+1);
			}

			//remember ngModel is the highest acheived step
			$scope.$watch('ngModel()', function() {

				for (var i = 0; i < prog.steps.length; i++) {
					prog.steps[i].class = prog.getClass(i+1);
				}

			});
		}
	}
});


'use strict';

angular.module('easyj', [
	'ngRoute',
	'ngStorage',
	'ngTagsInput',
	'easyj.about',
	'easyj.wiz',
	'easyj.progress',
	'easyj.progress',
	'easyj.help'
	])
	.config(function ($routeProvider) {
		$routeProvider
			.when('/', {
				templateUrl: 'app/main/main.html',
				controller: 'MainCtrl'
			})
			.otherwise({
				redirectTo: '/'
			});
	})
;

'use strict';

angular.module('easyj')
	.controller('NavbarCtrl', function ($scope, $location) {

		var nav = this;

		nav.isActive = function (viewLocation) {
			return viewLocation === $location.path();
		};
	});


var app = angular.module('easyj.help', []);

app.directive('bbHelp', function() {
	return {
		restrict: 'A',
		replace: true,
		templateUrl: 'app/components/help/help.html',
		controllerAs: 'prog',
		controller: function($scope) {

		},
		transclude: true,
		link: function(scope, element, attrs, ctrl, transclude) {

			$(element).popover({
				trigger: "manual",
				animation: false,
				html : true,
				content:$(element).find('[ng-transclude]').html()
			}).on("mouseenter", function () {
					var _this = this;
					$(this).popover("show");
					$(".popover").on("mouseleave", function () {
							$(_this).popover('hide');
					});
			}).on("mouseleave", function () {
					var _this = this;
					setTimeout(function () {
							if (!$(".popover:hover").length) {
									$(_this).popover("hide");
							}
					}, 300);
			});//http://stackoverflow.com/a/19684440/429544

		}
	}
});


'use strict';

angular.module('easyj')
	.controller('FooterCtrl', function ($scope) {
		$scope.date = new Date();
	});

'use strict';

var app = angular.module('easyj.wiz', [
	'ngRoute',
	'ngStorage',
	'easyj.export'
]);

app.config(function ($routeProvider) {
	$routeProvider
		.when('/wizard', {
			templateUrl: 'app/wiz/wiz.html'
		})
		.when('/wizard/:step', {
			templateUrl: function () {
				return 'app/wiz/steps/wiz_steps.html';
			},
			controller: 'WizCtrl',
			controllerAs: 'wiz'
		});
});



//zero pad a number
function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}


app.controller('WizCtrl', function (Robot, $scope, $routeParams, $localStorage, $window) {
	var wiz = this;
	wiz.stepComplete = function (num) {
		if (typeof $localStorage.curStep === 'undefined') {
			$localStorage.curStep = num+1;
		} else {
			if (num >= $localStorage.curStep) {
				$localStorage.curStep = num+1;
			}
		}
		$window.location.href = '/#/wizard/'+(parseInt($routeParams.step)+1);
	};
	wiz.getCurStep = function () {
		return $localStorage.curStep || 1;
	};

	$scope.invalidateFutureSteps = wiz.invalidateFutureSteps = function() {
		if ($routeParams.step < wiz.getCurStep()) {
			$localStorage.curStep = parseInt($routeParams.step);
		}
	};
	wiz.test = function() {
		console.log("Test");
	};

	//@Make sure that you can't get to a step that isn't complete.
	if ($routeParams.step > this.getCurStep()) {
		$window.location.href = '/#/wizard/'+this.getCurStep();
		return;
	}

	this.step = pad($routeParams.step,2); //this is used to determine what template to load



	//make robot available to all views
	$scope.Robot = Robot;

	$scope.$localStorage = $localStorage;
});

app.controller('Wiz1Ctrl', function (Robot, $scope) {
	this.num = 1;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return (isValid && Robot.data.hasDrivetrain == 'yes') || Robot.data.hasDrivetrain == 'no';
	};
});
app.controller('Wiz2Ctrl', function (Robot, $scope) {
	this.num = 2;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return (isValid && Robot.data.hasOtherMotors == 'yes') || Robot.data.hasOtherMotors == 'no';
	};

});
app.controller('Wiz3Ctrl', function (Robot, $scope) {
	this.num = 3;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return (isValid && Robot.data.hasPneumatics == 'yes') || Robot.data.hasPneumatics == 'no';
	};
});
app.controller('Wiz4Ctrl', function (Robot, $scope) {
	this.num = 4;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return isValid;
	};
});
app.controller('Wiz5Ctrl', function (Robot, $scope) {
	this.num = 5;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return (isValid && Robot.data.hasDIN == 'yes') || Robot.data.hasDIN == 'no';
	};

});
app.controller('Wiz6Ctrl', function (Robot, $scope) {
	this.num = 6;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return (isValid && Robot.data.hasAIN == 'yes') || Robot.data.hasAIN == 'no';
	};
});
app.controller('Wiz7Ctrl', function (Robot, $scope) {
	this.num = 7;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return isValid;
	};
});
app.controller('Wiz8Ctrl', function (Robot, $scope) {
	this.num = 8;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return isValid;
	};
});
app.controller('Wiz9Ctrl', function (Robot, $scope, $timeout, $window) {
	var step = this;
	step.num = 9;
	step.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	step.currentSubsystem = Robot.getSubsystems()[0].name;
	step.currentAction = Robot.getSubsystems()[0].actions[0].text;
	if (_.isNull(document.getElementById('blocklyDiv'))) {
		console.error('It seems the blocklyDiv is missing.');
		return;
	}
	Blockly.inject(document.getElementById('blocklyDiv'),
	{
		path:'/blockly-src/', //@todo this will need to change in prod
		toolbox: document.getElementById('toolbox'),
		media:'/blockly-src/media/'
	});
	$(document).trigger("blocklyLoaded");

	Blockly.mainWorkspace.reset = function() {
		$timeout(function() { //this waits for the {{step.currentAction}} to be injected before reloading blocks
			// Remove all blocks
			Blockly.mainWorkspace.clear();
			//Load the starting blocks
			var startingBlocks = document.getElementById('startingblocks');

			if (startingBlocks.innerHTML !== '') //if there are blocks
			{
				var xml = startingBlocks; //Blockly.Xml.textToDom(startingBlocks);
				Blockly.Xml.domToWorkspace(Blockly.mainWorkspace, xml);
			} else {
				console.error('No starting blocks to load');
			}
		}, 0);
	};
	// $timeout(function() {
	// 	Blockly.mainWorkspace.reset();
	// }, 0);


	//Changes the active Action
	step.setActiveAction = function(newAction) {

		if(!_.contains(_.pluck(Robot.getActions(step.currentSubsystem), 'text'), newAction)) {
			alert('Action \"' + newAction + '\" does not exist.');
			return;
		}
		step.currentAction = newAction;
		var act = _.find(Robot.getActions(step.currentSubsystem), {'text':step.currentAction});

		if(Blockly.mainWorkspace && Blockly.mainWorkspace.getMetrics()) {
			var saved = {
				proc: act.xmlcode,
				vars: Robot.getSubsystem(step.currentSubsystem).stateVars
			};

			var dom = $('#startingblocks').clone();
			//Set the procedure name properly even if the html hasn't finished rendering
			$('block[type="procedures_defreturn"] mutation', dom).attr('procname', step.currentAction);


			if (saved.vars) {
				$('block[type="state_vars"]',dom).html($('block[type="state_vars"]',saved.vars).html());
			}
			if (saved.proc) {
				$('block[type="procedures_defreturn"]',dom).html($('block[type="procedures_defreturn"]',saved.proc).html());
			}

			dom = dom.get(0); //get the raw dom element from the jquery element
			Blockly.mainWorkspace.clear();
			Blockly.Xml.domToWorkspace(Blockly.mainWorkspace, dom);


		// 	//Reload the Blockly toolbox to account for changes in blocks
		// 	$timeout(function() {
		// 		if(Blockly.Toolbox.HtmlDiv) {
		// 			Blockly.Toolbox.HtmlDiv.innerHTML = '';
		// 			Blockly.languageTree = document.getElementById('blockly-toolbox');
		// 			Blockly.Toolbox.init();
		// 		}
		// 	}, 0);
		}
	};
	step.nextAction = function() {
		var index = _.indexOf(_.pluck(Robot.getActions(step.currentSubsystem), 'text'), step.currentAction);
		if (index+1 >= Robot.getActions(step.currentSubsystem).length ) {
			console.error('Unable to go to next action, because there are no more actions!');
		} else {
			step.setActiveAction(Robot.getActions(step.currentSubsystem)[index+1].text);
		}
	};
	step.isActionComplete = function(action, subsys) {
		if (_.isUndefined(action)) {
			action = step.currentAction;
		}
		if (_.isUndefined(subsys)) {
			subsys = step.currentSubsystem;
		}
		var act = _.find(Robot.getActions(subsys), {'text':action});
		return (!_.isUndefined(act.isDone) && act.isDone);
	};

	//true when every action in the current susbsystem is true.
	step.isSubsystemComplete = function(subsys) {
		if (_.isUndefined(subsys)) {
			subsys = step.currentSubsystem;
		}
		if (_.isObject(subsys)) {
			subsys = subsys.name;
		}
		var a = _.map(Robot.getActions(subsys), function(el) {
			return step.isActionComplete(el.text, subsys);
		});
		return _.every(a);
	};
	step.nextSubsystem = function() {

		var index = _.indexOf(_.pluck(Robot.getSubsystems(), 'name'), step.currentSubsystem);
		if (index+1 >= Robot.getSubsystems().length ) {
			console.error('Unable to go to next subsystem, because there are no more subsystems!');
		} else {
			step.currentSubsystem = Robot.getSubsystems()[index+1].name;
			var action = Robot.getSubsystems()[index+1].actions[0].text;
			step.setActiveAction(action);
		}
	};
	step.isStepComplete = function() {
		//
		var done = _.map(Robot.getSubsystems(), function(subsys) {
			return step.isSubsystemComplete(subsys);
		});
		return _.every(done);
	};

	//used for the current subsystem dropdown
	step.currentSubsysChange = function() {
		step.setActiveAction(Robot.getActions(step.currentSubsystem)[0].text);
	};

	//save the users code and blocks
	step.persistCode = function() {

		var act = _.find(Robot.getActions(step.currentSubsystem), {'text':step.currentAction});


		var stateVars = Blockly.extensions.blockTypeToDom('state_vars');
		stateVars = Blockly.Xml.domToPrettyText(stateVars);
		Robot.getSubsystem(step.currentSubsystem).stateVars = stateVars;

		var proc = Blockly.extensions.blockTypeToDom('procedures_defreturn');
		proc = Blockly.Xml.domToPrettyText(proc);
		act.xmlcode = proc;

		if ( !act.isDone && Blockly.mainWorkspace.getAllBlocks().length > 2 ) {
			$scope.$apply(function () {
				act.isDone = true; //@todo need a better way to determine if their code is "done"
			});
		}
	};
	//Save the user's code if they refresh the page.
	// Sometimes mutator changes were not being saved
	//$window.onunload =
	$window.onbeforeunload = function() {
		// console.log("Here", Blockly.Xml.domToPrettyText(Blockly.Xml.workspaceToDom(Blockly.mainWorkspace)));
		//@todo For some reason mutations are not saved if executed just before a refresh
	};
	$scope.$on('$routeChangeStart', function(next, current) {
		console.log("Route Change Start");
		step.persistCode();
		Blockly.mainWorkspace.dispose();
	});

	/**
	 * When the workspace changes:
	 */
	function onchange() {
		step.persistCode();
		//whenever the workspace changes invalidate future steps
		step.invalidateFutureSteps();
	}

	// After the page is finished rendering, loadup blockly blocks
	$timeout(function() {
		step.setActiveAction(Robot.getActions(step.currentSubsystem)[0].text);
		Blockly.addChangeListener(onchange);
	}, 0);


});
app.controller('Wiz10Ctrl', function ($scope) {
	this.num = 10;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return isValid;
	};
});
app.controller('Wiz11Ctrl', function ($scope) {
	this.num = 11;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.complete = function (isValid) {
		return isValid;
	};
});
app.controller('Wiz12Ctrl', function ($scope) {
	this.num = 12;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
});
app.controller('Wiz13Ctrl', function ($scope) {
	this.num = 13;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
});
app.controller('Wiz14Ctrl', function ($scope, Robot, Exporter) {
	this.num = 14;
	this.invalidateFutureSteps = $scope.$parent.invalidateFutureSteps
	this.export = function() {
		Exporter.toEclipse(Robot.data);
	};
});

function invalidateFutureSteps(self) {
	var el = angular.element(self);
	el.controller().invalidateFutureSteps();
}

'use strict';

var app = angular.module('easyj.wiz');

app.factory('Robot', function($localStorage, $window){

	//empty templates
	var EMPTY_SOL = {name:'',port:'',type:''};
	var EMPTY_CON = _.clone(EMPTY_SOL); //motor controller
	var EMPTY_HID = _.clone(EMPTY_SOL);
	var EMPTY_AIO = _.clone(EMPTY_SOL);
	var EMPTY_DIO = _.clone(EMPTY_SOL);
	var EMPTY_SUB = {name:'', actions:"", disabled:false};
	var EMPTY_CMD = {name:'', requires:[]};
	//@note: when cloning EMPTY_* make sure to use cloneDeep when an array is involved

	var Robot ={};

	var def = {
		//step 1
		hasDrivetrain: undefined,
		numMotors: undefined,
		drivetrain: {
			mcType: undefined,
			controllers: [],
			numMotors: undefined,
			type: undefined,
		},

		driveType: undefined,
		controllers: [_.clone(EMPTY_CON)],
		//step 2
		solenoids: [_.clone(EMPTY_SOL)],
		hasPneumatics: undefined,

		hids: [{name:'driver1',port:'0',type:''}],
		sensors:{
			analog: [_.clone(EMPTY_AIO)],
			digital: [_.clone(EMPTY_DIO)],
		},
		// This really should be conditional based on the users earlier selected pref
		subsystems:[{name:'Drivetrain',actions:['drive','stop'], disabled:false}],

		commands:[{name: 'ArcadeDrive',requires: ['Drivetrain'],type: 'cmd'}],
		number: undefined
	};

	Robot.DEBUG = false;

	// //the data about the user's robot stored here
	Robot.data = $localStorage.$default(_.clone(def));

	Robot.limits = {
		PWM: 10,
		Sol: 8,
		ds: {
			USB: 4
		},
		sensors: {
			analog: 4,
			digital: 10
		},
		relay: 4
	};

	Robot.controller = {};
	Robot.controller.choices = [
		{
			name:'victorsp',
			prettyName: 'Victor SP',
			img:'victor_sp.jpg',
		},{
			name:'victor',
			prettyName:'Victor',
			img:'victor_888.jpg',
		},{
			name:'talon',
			prettyName: 'Talon SR',
			img:'talon_sr.jpg',
		},{
			name:'talonsrx',
			prettyName: 'Talon SRX (PWM)',
			img:'talon_srx.jpg',
		},{
			name:'jaguar',
			prettyName:'Jaguar (Not Recommended)',
			img:'jaguar.jpg',
		},{
			name:'spark',
			prettyName: 'Spark',
			img: 'spark.jpg'
		},{
			name:'sd540',
			prettyName: 'SD540',
			img: 'sd540.jpg'
		}
	];
	Robot.controller.toPretty = function(name) {
		var out =_.find(Robot.controller.choices, function (el) {
			return el.name === name;
		});
		return out && out.prettyName;
	};

	Robot.reset = function() {
		$localStorage.$reset();
		$localStorage.$default(_.clone(def));
		$localStorage.curStep = 1;
		$window.location.href = '/#/wizard/'+$localStorage.curStep;
	};

	Robot.resetBlocks = function() {
		for (var i = 0; i < Robot.data.subsystems.length; i++) {
			var act = Robot.data.subsystems[i].actions;
			delete Robot.data.subsystems[i].stateVars;
			for (var j = 0; j < act.length; j++) {
				delete act[j].code;
				delete act[j].xmlcode;
				delete act[j].isDone;
			}
		}
		Blockly.mainWorkspace.reset();
	};

	Robot.getSubsystems = function() {
		return _.filter(Robot.data.subsystems, function(el){
			if (! el.disabled) {
				return el;
			}
		});
	};
	Robot.getSubsystem = function(name) {
		return _.find(Robot.data.subsystems, {'name':name});
	};
	//when displaying the subsystems form, make sure to show an empty slot.
	Robot.getInitialSubsystems = function() {
		var subsys = Robot.getSubsystems();
		if (subsys.length === 0) {
			Robot.data.subsystems.push(_.cloneDeep(EMPTY_SUB));
		}
		return Robot.getSubsystems();
	};

	Robot.getActions = function(subsys) {
		return Robot.getSubsystem(subsys) && Robot.getSubsystem(subsys).actions;
	};

	// Drivetrain ----------------------------------------------------------------

	Robot.drivetrainChange = function() {
		Robot.data.subsystems = _.map(Robot.data.subsystems, function(el) {
			if (el.name === 'Drivetrain') {
				el.disabled = (Robot.data.hasDrivetrain !== 'yes');
			}
			return el;
		});
	};

	Robot.getNumPWM = function() {
		return _.map(_.range(0, Robot.limits.PWM), function(el){
			return el.toString();
		});
	};

	Robot.isPWMUsed = function(n) {
		var out = false;
		n=n.toString();
		//check drivetrain
		for (var i = 0; i < Robot.data.drivetrain.controllers.length; i++) {
			if (Robot.data.drivetrain.controllers[i].port.toString() === n.toString()) {
				out = true;
				break;
			}
		}
		//check other controllers
		for (i = 0; i < Robot.data.controllers.length; i++) {
			if (Robot.data.controllers[i].port.toString() === n.toString()) {
				out = true;
				break;
			}
		}
		return out;
	};

	Robot.numMotorsChange = function () {
		Robot.data.drivetrain.controllers = [];
		var controllers = [];
		if (Robot.data.drivetrain.numMotors === '2') {
			controllers = ['left','right'];
		} else if (Robot.data.drivetrain.numMotors === '4') {
			controllers = ['frontLeft','rearLeft','frontRight','rearRight'];
		} else {
			throw new Error('Invalid number of motors');
		}

		for (var i = 0; i < controllers.length; i++) {
			var con = _.clone(EMPTY_CON);
			con.name = controllers[i];
			con.port = ((! Robot.isPWMUsed(i)) ? i : '').toString() ;
			con.type = Robot.data.drivetrain.mcType;
			Robot.data.drivetrain.controllers.push(con);
		}
	};

	Robot.mcTypeChange = function () {
		Robot.data.drivetrain.controllers = _.map(Robot.data.drivetrain.controllers, function(el){
			el.type = Robot.data.drivetrain.mcType;
			return el;
		});
	};

	// Motors --------------------------------------------------------------------
	Robot.addController = function() {
		if ( (Robot.data.controllers.length - Robot.data.drivetrain.controllers.length) < Robot.limits.PWM) {
			Robot.data.controllers.push(_.clone(EMPTY_CON));
		}

	};
	Robot.removeController = function(item) {
		Robot.data.controllers = Robot.data.controllers.filter(function(el){
			return el !== item;
		});
	};


	// Pneumatics ----------------------------------------------------------------

	Robot.isSolPortUsed = function(n) {
		var out = false;
		n=n.toString();
		for (var i = 0; i < Robot.data.solenoids.length; i++) {
			if (Robot.data.solenoids[i].port === n) {
				out = true;
				break;
			}
		}
		return out;
	};
	Robot.getNumSolPorts = function() {
		return _.map(_.range(0, Robot.limits.Sol), function(el){
			return el.toString();
		});
	};

	Robot.addSolenoid = function() {
		if (Robot.data.solenoids.length < Robot.limits.Sol) {
			Robot.data.solenoids.push(_.clone(EMPTY_SOL));
		}

	};
	Robot.removeSolenoid = function(item) {
		Robot.data.solenoids = Robot.data.solenoids.filter(function(el){
			return el !== item;
		});
	};

	// DS Inputs -----------------------------------------------------------------
	Robot.getNumUSBPorts = function() {
		return _.map(_.range(0, Robot.limits.ds.USB), function(el){
			return el.toString();
		});
	};
	Robot.isUSBPortUsed = function(n) {
		var out = false;
		n=n.toString();
		for (var i = 0; i < Robot.data.hids.length; i++) {
			if (Robot.data.hids[i].port === n) {
				out = true;
				break;
			}
		}
		return out;
	};
	Robot.addHID = function() {
		if (Robot.data.hids.length < Robot.limits.ds.USB) {
			Robot.data.hids.push(_.clone(EMPTY_HID));
		}
	};
	Robot.removeHID = function(item) {
		Robot.data.hids = Robot.data.hids.filter(function(el){
			return el !== item;
		});
	};
	// Digital Inputs ------------------------------------------------------------
	Robot.getNumDigitalPorts = function() {
		return _.map(_.range(0, Robot.limits.sensors.digital), function(el){
			return el.toString();
		});
	};
	Robot.isDigitalPortUsed = function(n) {
		var out = false;
		n=n.toString();
		for (var i = 0; i < Robot.data.sensors.digital.length; i++) {
			if (Robot.data.sensors.digital[i].port === n) {
				out = true;
				break;
			}
		}
		return out;
	};
	Robot.addDigitalSensor = function() {
		if (Robot.data.sensors.digital.length < Robot.limits.sensors.digital) {
			Robot.data.sensors.digital.push(_.clone(EMPTY_AIO));
		}
	};
	Robot.removeDigitalSensor = function(item) {
		Robot.data.sensors.digital = Robot.data.sensors.digital.filter(function(el){
			return el !== item;
		});
	};
	// Analog Inputs -------------------------------------------------------------
	Robot.getNumAnalogPorts = function() {
		return _.map(_.range(0, Robot.limits.sensors.analog), function(el){
			return el.toString();
		});
	};
	Robot.isAnalogPortUsed = function(n) {
		var out = false;
		n=n.toString();
		for (var i = 0; i < Robot.data.sensors.analog.length; i++) {
			if (Robot.data.sensors.analog[i].port === n) {
				out = true;
				break;
			}
		}
		return out;
	};
	Robot.addAnalogSensor = function() {
		if (Robot.data.sensors.analog.length < Robot.limits.sensors.analog) {
			Robot.data.sensors.analog.push(_.clone(EMPTY_AIO));
		}
	};
	Robot.removeAnalogSensor = function(item) {
		Robot.data.sensors.analog = Robot.data.sensors.analog.filter(function(el){
			return el !== item;
		});
	};
	 // Subsystems ---------------------------------------------------------------
	Robot.addSubsystem = function() {
		Robot.data.subsystems.push(_.cloneDeep(EMPTY_SUB));

	};
	Robot.removeSubsystem = function(item) {
		Robot.data.subsystems = Robot.data.subsystems.filter(function(el){
			return el !== item;
		});
	};
	// Commands ------------------------------------------------------------------

	Robot.addCommand = function() {
		if (!_.isArray(Robot.data.commands)) {
			Robot.data.commands = [];
		}
		Robot.data.commands.push(_.clone(EMPTY_CMD));
	};
	Robot.removeCommand = function(item) {
		Robot.data.commands = Robot.data.commands.filter(function(el){
			return el !== item;
		});
	};
	Robot.addRequires = function(cmd) {
		if (cmd.requires.length < Robot.data.subsystems.length &&
			_.indexOf(cmd.requires, '') === -1 ) {//not in list
			cmd.requires.push('ted');
		} else {
			console.error('Can\'t add requires.');
		}

	};

	// Debug ------------------------------------------------------------------
	Robot.toggleDebug = function (bool) {
		if (_.isUndefined(bool)) {
			bool=!Robot.DEBUG;
		}
		Robot.DEBUG = bool;
	}


	return Robot;
});

'use strict';

angular.module('easyj')
	.controller('MainCtrl', function () {
	});

'use strict';

var app = angular.module('easyj.export', []);

app.factory('Exporter', function(Robot){
	var data = Robot.data;

	var info = {
		team_number: data.number,
		pkgarr: ['org'],
	}
	var templatedir = "/assets/tpl/java";
	info.pkgarr.push('t'+info.team_number)
	info['package'] = info.pkgarr.join('.')

	// cam this is a change
	// templates to iterate through
	// this has the limitation that you can't have the same named classes in your project
	var files = [
		{
			template: 'Robot.java',
			parse: true,
			out:"src/"+info.pkgarr.join('/')+"/Robot.java",
			data: {
				'package': info['package'],
				'autos': [
					{
						type:"Default",
						name:"Default Command",
						command:"DefaultAuto"
					},{
						type:"Object",
						name:"Regular Command",
						command:"RegularAuto"
					}
				],
				subsystems: _.pluck(data.subsystems, "name")
			}
		},{
			template: 'JoystickAxisButton.java',
			parse: false,
			out:"src/edu/wpi/first/wpilibj/buttons/JoystickAxisButton.java",
		},{
			template: 'Xbox.java',
			parse: false,
			out:"src/edu/wpi/first/wpilibj/Xbox.java",
		},{
			template: 	'OI.java',
			parse: true,
			out: "src/"+info.pkgarr.join('/')+"/OI.java",
			data: {
				'package': info['package'],
				hids: data.hids,
				old: [
					{
						"name": "d1",
						"port": "0",
						"type": "joystick"
					},
					{
						"name": "d2",
						"port": "1",
						"type": "xbox"
					},
					{
						"name": "d3",
						"port": "2",
						"type": "ps"
					}
				],
				buttons: []
			}
		},{
			template: 'Constants.java',
			parse:true,
			out: "src/"+info.pkgarr.join('/')+"/Constants.java",
			data: {
				'package': info['package'],
			}
		},{
			template: 'build.properties',
			parse: true,
			out: 'build.properties',
			data: {
				'package': info['package'],
			}
		},{
			template: 'classpath.txt',
			parse: false,
			out:".classpath",
		},{
			template: 'project.txt',
			parse: false,
			out:".project",
		},
		// {
		// 	template: 'build.xml',
		// 	parse: false,
		// 	out:"build.xml",
		// }
	];

	if (data.hasDrivetrain == "yes") {
		var dt = data.drivetrain
		var subsys = _.where(data.subsystems, {"name": "Drivetrain"})
		if (subsys.length != 1) {
			console.err("Multiply defined subystem:",dt.subsystem)
		}
		var actions = subsys[0].actions
		//console.log(actions)
		var sen = _.where(data.sensors.analog, {"subsystem": dt.subsystem})
		sen = sen.concat(_.where(data.sensors.digital, {"subsystem": dt.subsystem}))

		files.push({
			template: 'Subsystem.java',
			parse: true,
			out: "src/"+info.pkgarr.join('/')+"/subsystems/"+dt.subsystem+".java",
			data: {
				'package': info['package'],
				name: dt.subsystem,
				sensors: sen,
				controllers: dt.controllers,
				methods: actions,
				solenoids: _.where(data.solenoids, {"subsystem": dt.subsystem})
			}
		});
	}

	//Other subsystems:
	for (var i =0; i < data.subsystems.length; i++){
		var sub = data.subsystems[i]
		if (sub.name != "Drivetrain"){
			sen = _.where(data.sensors.analog, {"subsystem": sub.name})
			sen = sen.concat(_.where(data.sensors.digital, {"subsystem": sub.name}))
			files.push({
				template: 'Subsystem.java',
				parse: true,
				out: "src/"+info.pkgarr.join('/')+"/subsystems/"+sub.name+".java",
				data: {
					'package': info['package'],
					name: sub.name,
					sensors: sen,
					controllers: _.where(data.controllers, {"subsystem": sub.name}),
					solenoids: _.where(data.solenoids, {"subsystem": sub.name}),
					methods: sub.actions,
				}
			})
		}
	}

	for (var i=0; i<data.commands.length; i++){
		var cmd = data.commands[i];
		//console.log(cmd)

		if (cmd.type == 'cmd'){
			files.push({
				template: 'Command.java',
				parse: true,
				out: "src/"+info.pkgarr.join('/')+"/commands/"+cmd.name+".java",
				data: {
					package: info.package,
					name: cmd.name,
					req: cmd.requires
				}
			})
		}
	}

	Handlebars.registerHelper('capFirst', function(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	});
	var path = {
		dirname: function(path) {
			var p= path.replace(/\\/g, '/').replace(/\/[^\/]*\/?$/, '');
			if (p == path) {
				return "";
			}
			return p;
		},
		basename: function(path) {
			return path.replace(/^.*(\\|\/|\:)/, '');
		},
		join: function(){
			var args = Array.prototype.slice.call(arguments);
			return args.join('/');
		}
	};

	var Exporter = {
		toEclipse: function(robotJson) {

			var zip = new JSZip();
			var deferreds = [];

			function render(item) {
				var deferred = $.Deferred();

				var urlPath = path.join(templatedir, item.template);

				$.get(urlPath, function( template ) {
					// console.log("GET", urlPath, template);

					var out = template;
					if (item.parse) {
						out = Handlebars.compile(template)(item.data);
					}

					var p = path.dirname(item.out);
					p = p.split('/');

					var f = null;
					for (var i = 0; i < p.length; i++) {
						if (!f) {
							f = zip.folder(p[i])
						} else {
							f = f.folder(p[i])
						}
					}
					f.file(path.basename(item.out), out);

					deferred.resolve();
				});
				return deferred;
			}

			for (var i=0; i<files.length; i++) {
				var item = files[i];
				deferreds.push(render(item));
			}

			$.when.apply($, deferreds).done(function () {
				var blob = zip.generate({type:"blob"});
				saveAs(blob, data.number+"_code.zip");
			});
		}
	};



	return Exporter;

});

'use strict';

angular.module('easyj.about', ['ngRoute'])
	.config(function ($routeProvider) {
		$routeProvider
			.when('/about', {
				templateUrl: 'app/about/about.html',
				controller: 'AboutCtrl'
			});
	})
;

angular.module('easyj.about')
	.controller('AboutCtrl', function ($scope) {
		$scope.awesomeThings = [
			{
				'title': 'AngularJS',
				'url': 'https://angularjs.org/',
				'description': 'HTML enhanced for web apps!',
				'logo': 'angular.png'
			},
			{
				'title': 'BrowserSync',
				'url': 'http://browsersync.io/',
				'description': 'Time-saving synchronised browser testing. During development file changes trigger browser reload.',
				'logo': 'browsersync.png'
			},
			{
				'title': 'GulpJS',
				'url': 'http://gulpjs.com/',
				'description': 'The streaming build system. Used to compress and minify the code for production.',
				'logo': 'gulp.png'
			},
			// {
			//   'title': 'Jasmine',
			//   'url': 'http://jasmine.github.io/',
			//   'description': 'Behavior-Driven JavaScript.',
			//   'logo': 'jasmine.png'
			// },
			// {
			//   'title': 'Karma',
			//   'url': 'http://karma-runner.github.io/',
			//   'description': 'Spectacular Test Runner for JavaScript.',
			//   'logo': 'karma.png'
			// },
			// {
			//   'title': 'Protractor',
			//   'url': 'https://github.com/angular/protractor',
			//   'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
			//   'logo': 'protractor.png'
			// },
			{
				'title': 'jQuery',
				'url': 'http://jquery.com/',
				'description': 'jQuery is a fast, small, and feature-rich JavaScript library.',
				'logo': 'jquery.jpg'
			},
			{
				'title': 'Bootstrap',
				'url': 'http://getbootstrap.com/',
				'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
				'logo': 'bootstrap.png'
			},
			{
				'title': 'Yeoman',
				'url': 'http://yeoman.io/',
				'description': 'Yeoman helps you to kickstart new projects, prescribing best practices and tools to help you stay productive.',
				'logo': 'yeoman.png'
			},{
				'title': 'Blockly',
				'url': 'https://developers.google.com/blockly/',
				'description': 'Blockly is a library for building visual programming editors. Used for the block coding steps.',
				'logo': 'blockly.png'
			},{
				'title': 'Lo-Dash',
				'url': 'https://lodash.com/',
				'description': 'A utility library delivering consistency, customization, performance, & extras',
				'logo': 'lodash.png'
			},{
				'title': 'Bower',
				'url': 'http://bower.io/',
				'description': 'A package manager for the web. Used to manage the frontend dependencies and libraries.',
				'logo': 'bower.png'
			},{
				'title': 'NPM',
				'url': 'https://www.npmjs.com/',
				'description': 'Node Package manager. Used for gulp modules and dependencies.',
				'logo': 'npm.png'
			},{
				'title': 'generator-gulp-angular',
				'url': 'https://github.com/Swiip/generator-gulp-angular',
				'description': 'A fantastic generator for Yeoman which helps setup the whole project structure.',
				'logo': 'generator-gulp-angular-logo.png'
			},{
				'title': 'Handlebars.js',
				'url': 'http://handlebarsjs.com/',
				'description': 'Minimal {{templating}} used for code generation.',
				'logo': 'handlebars.png'
			}
			// ,{
			// 	'title': 'Moment.js',
			// 	'url': 'http://momentjs.com/',
			// 	'description': 'Parse, validate, manipulate, and display dates in JavaScript.',
			// 	'logo': 'moment.jpg'
			// }


		];
		angular.forEach($scope.awesomeThings, function(awesomeThing) {
			awesomeThing.rank = Math.random();
		});
	});

angular.module("easyj").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div class=\"container\"><div class=\"jumbotron text-center\"><h1>RoboCode Wizard</h1><p>The RoboCode Wizard is built using these fantatsic tools and technologies</p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/tech/{{awesomeThing.logo}}\" alt=\"{{awesomeThing.title}}\" ng-hide=\"awesomeThing.logo == \'\'\"><div class=\"caption\"><h3>{{awesomeThing.title}}</h3><p>{{awesomeThing.description}}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{awesomeThing.url}}</a></p></div></div></div></div></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div class=\"jumbotron\"><h1>Welcome to the RoboCode Wizard <small>for FRC robots</small></h1><h2>What would you like to do?</h2><a ng-href=\"#/todo\" class=\"btn btn-primary\">Open a project</a> <a ng-href=\"#/wizard\" class=\"btn btn-success\">Start a new Project</a></div><div class=\"row\"><div class=\"col-md-6\"><h2>What is The RoboCode Wizard?</h2><p>The RoboCode Wizard is a web based system which allows easy creaton of WPI-Lib Command Based robot code projects via an easy to understand step-by step interface.</p></div><div class=\"col-md-6\"></div><div class=\"col-md-6\"><h2>\"Command based programming\"?</h2><blockquote><i class=\"fa fa-quote-left\"></i> WPILib supports a method of writing programs called \"Command based programming\". Command based programming is a design pattern to help you organize your robot programs. Some of the characteristics of robot programs that might be different from other desktop programs are:<ul><li>Activities happen over time, for example a sequence of steps to shoot a Frisbee or raise an elevator and place a tube on a goal.</li><li>These activities occur concurrently, that is it might be desirable for an elevator, wrist and gripper to all be moving into a pickup position at the same time to increase robot performance.</li><li>It is desirable to test the robot mechanisms and activities each individually to help debug your robot.</li><li>Often the program needs to be augmented with additional autonomous programs at the last minute, perhaps at competitions, so easily extendable code is important.</li></ul>Command based programming supports all these goals easily to make the robot program much simpler than using some less structured technique. <i class=\"fa fa-quote-right\"></i></blockquote><a href=\"http://wpilib.screenstepslive.com/s/4485/m/13810/l/241892-what-is-command-based-programming\">Read the WPILib docs for more.</a></div></div></div>");
$templateCache.put("app/wiz/mc.html","<div class=\"col-lg-4\"><figure class=\"figure\" ng-repeat=\"mc in Robot.controller.choices\" style=\"display:inline-block;\"><img ng-src=\"assets/images/mc/{{mc.img}}\" class=\"img-rounded\" alt=\"{{mc.alt}}\" width=\"150\"><figcaption class=\"figure-caption text-center\">{{mc.prettyName}}</figcaption></figure></div>");
$templateCache.put("app/wiz/wiz.html","<div class=\"container\"><div class=\"jumbotron text-center\"><h1>Welcome to the EasyJ Wizard</h1><p class=\"lead\">This wizard will guide you through the process of creating your <strong>command based</strong> robot code.</p><p><a class=\"btn btn-lg btn-primary\" href=\"#/wizard/1\">Begin</a></p></div></div>");
$templateCache.put("app/components/footer/footer.html","<div class=\"container-fluid\" ng-controller=\"FooterCtrl\"><hr><p><a href=\"#about\" class=\"stealthlink\" data-toggle=\"modal\">RoboCode Wizard</a> - <a href=\"http://techwizworld.net\">Techplex Labs -- Blake Bourque</a> 2025-{{date | date:\'yyyy\'}}</p></div>");
$templateCache.put("app/components/help/help.html","<i class=\"fa fa-2x fa-question-circle text-primary\" data-toggle=\"popover\" style=\"margin-top: -8px;\"><div class=\"hidden\" ng-transclude=\"\"></div></i>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\" ng-controller=\"NavbarCtrl as nav\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"#/\" title=\"RoboCodeWizard\"><img src=\"assets/images/logo.png\" alt=\"EasyJ Logo\" height=\"40px\" style=\"margin-top: -10px;\"></a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li ng-class=\"{ active: nav.isActive(\'/\')}\"><a ng-href=\"#/\">Home</a></li><li ng-class=\"{ active: nav.isActive(\'/about\')}\"><a ng-href=\"#/about\">About</a></li><li><a ng-href=\"http://www.techwizworld.net/contact.html\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right\"><li></li></ul></div></div></nav>");
$templateCache.put("app/components/progress/progress.html","<div class=\"row bs-wizard\"><div class=\"col-xs-2 bs-wizard-step\" ng-class=\"prog.getClass($index+1, ngModel())\" data-idx=\"{{$index+1}}\" ng-repeat=\"step in prog.steps\"><div class=\"text-center bs-wizard-stepnum\">{{step.name || \'Step \'+($index+1)}}</div><div class=\"progress\"><div class=\"progress-bar\"></div></div><a href=\"{{prog.baseLink}}{{$index+1}}\" class=\"bs-wizard-dot\"></a><div class=\"bs-wizard-info text-center\">{{step.desc}}</div></div></div>");
$templateCache.put("app/wiz/steps/debug.html","<div class=\"col-lg-4\"><button ng-click=\"Robot.toggleDebug()\" class=\"btn\">Debug</button><div ng-show=\"Robot.DEBUG\"><button ng-click=\"Robot.reset()\" class=\"btn\">Reset</button> <button ng-click=\"Robot.resetBlocks()\" class=\"btn\">Clear Blocks</button> <span>Step: {{$localStorage.curStep}}</span><div class=\"\"><h4>Robot Data:</h4><pre>{{Robot.data | json:4}}</pre><h4>Robot Limits:</h4><pre>{{Robot.limits | json:4}}</pre></div></div></div>");
$templateCache.put("app/wiz/steps/wiz_01.html","<div class=\"row\" ng-controller=\"Wiz1Ctrl as step\"><form name=\"drivetrain\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Drivetrain</h1><ol><li>Does your robot have a drivetrain?<div class=\"radio\"><label><input type=\"radio\" value=\"yes\" ng-model=\"Robot.data.hasDrivetrain\" ng-change=\"Robot.drivetrainChange()\"> Yes, it has wheels!</label></div><div class=\"radio\"><label><input type=\"radio\" value=\"no\" required=\"\" ng-model=\"Robot.data.hasDrivetrain\" ng-change=\"Robot.drivetrainChange()\"> No, its stationary.</label></div></li><li ng-show=\"Robot.data.hasDrivetrain == \'yes\'\">What type of motor controllers will be used?<div bb-help=\"\" title=\"More Motor Controller\"><p>Drivetrains with one CIM Motor per side will not work with Jaguar Motor Controllers as the Jaguar Controller can\'t handle the current spikes.</p><p>Victors Have the highest peak current output which roughly equates to maximum acceleration.</p></div><div class=\"form-group\"><select ng-model=\"Robot.data.drivetrain.mcType\" class=\"form-control form-control-inline\" ng-change=\"Robot.mcTypeChange()\" required=\"\"><option value=\"\" disabled=\"\">Choose a type</option><option value=\"{{mc.name}}\" ng-repeat=\"mc in Robot.controller.choices\" ng-selected=\"{{mc.name == Robot.data.drivetrain.mcType}}\">{{mc.prettyName}}</option></select></div></li><li ng-show=\"Robot.data.drivetrain.mcType && Robot.data.hasDrivetrain == \'yes\'\">How many motors does it use?<div class=\"radio\"><label><input type=\"radio\" value=\"2\" required=\"\" ng-change=\"Robot.numMotorsChange()\" ng-model=\"Robot.data.drivetrain.numMotors\"> 2 motors</label></div><div class=\"radio\"><label><input type=\"radio\" value=\"4\" required=\"\" ng-change=\"Robot.numMotorsChange()\" ng-model=\"Robot.data.drivetrain.numMotors\"> 4 motors (also for 6 or 8 wheel drive)<div bb-help=\"\" title=\"More Motor Controller\"><p>The code can be configured for a max of two pairs of outputs.</p><p>PWM Signals can be easily split using a <a href=\"http://www.andymark.com/product-p/am-2261.htm\" target=\"_blank\">Servo Y-Cable</a>.</p></div></label></div></li><li ng-show=\"Robot.data.drivetrain.mcType && Robot.data.drivetrain.numMotors && Robot.data.hasDrivetrain == \'yes\'\">What type of driving will you be doing?<div class=\"radio\"><label><input type=\"radio\" ng-model=\"Robot.data.drivetrain.type\" value=\"arcade\" required=\"\"> arcade drive (most people use this)<div bb-help=\"\" title=\"Arcade Drive\"><p>Much like a classic arcade game, arcade drive uses a single joystick. The Y-axis of the joystick is move value, forward/backward speed. The X-axis is the turn amount.</p><p>When in doubt, use arcade drive.</p></div></label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"Robot.data.drivetrain.type\" value=\"tank\"> tank drive<div bb-help=\"\" title=\"Tank Drive\"><p>Tank drive uses a two joysticks. The Y-axis of the joystick1 controls the left side of the drivetrain and joystick2 controls the right side of the drivetrain.</p><p>When in doubt, use arcade drive.</p></div></label></div><div class=\"radio hidden\" ng-show=\"Robot.data.drivetrain.numMotors == 4 || Robot.data.drivetrain.numMotors == 8\"><label><input type=\"radio\" ng-model=\"Robot.data.drivetrain.type\" value=\"mecanum\"> mecanum drive</label></div></li><li ng-show=\"Robot.data.drivetrain.mcType && Robot.data.drivetrain.type && Robot.data.hasDrivetrain == \'yes\'\">What ports are your motors connected to?<table class=\"table\"><thead><th>Motor Name</th><th><abbr title=\"Pulse Width Modulation - Used for motor control\">PWM</abbr> Port</th><th>Type</th></thead><tbody><tr ng-repeat=\"controller in Robot.data.drivetrain.controllers\"><td><input ng-model=\"controller.name\" required=\"\" class=\"form-control form-control-inline\" type=\"text\"></td><td><select ng-model=\"controller.port\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a port</option><option ng-repeat=\"port in Robot.getNumPWM()\" value=\"{{port}}\" ng-disabled=\"Robot.isPWMUsed(port)\" ng-selected=\"{{port == controller.port}}\">{{port}} {{Robot.isPWMUsed(port)? \'used\' : \'\'}}</option></select></td><td>{{Robot.controller.toPretty(controller.type)}}</td></tr></tbody></table></li><li><button class=\"btn btn-primary\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(drivetrain.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/mc.html\'\"></div><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_02.html","<div class=\"row\" ng-controller=\"Wiz2Ctrl as step\"><form name=\"motors\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Motors</h1><ol><li>Does your robot have more motors? (other than the drive train motors)<div class=\"radio\"><label><input type=\"radio\" value=\"yes\" ng-model=\"Robot.data.hasOtherMotors\"> Yes, it has more motors!</label></div><div class=\"radio\"><label><input type=\"radio\" value=\"no\" required=\"\" ng-model=\"Robot.data.hasOtherMotors\"> Nope.</label></div></li><li ng-show=\"Robot.data.hasOtherMotors == \'yes\'\"><button ng-click=\"Robot.addController()\" class=\"btn btn-success pull-right\">Add Motor</button><p>What motor controllers are used?</p><p>How are they connected to your RoboRio?</p><table class=\"table\"><thead><th>Motor Name</th><th><abbr title=\"Pulse Width Modulation - Used for motor control\">PWM</abbr> Port</th><th>Type</th></thead><tbody><tr ng-repeat=\"controller in Robot.data.controllers\"><td><input ng-model=\"controller.name\" required=\"\" class=\"form-control form-control-inline\" type=\"text\"></td><td><select ng-model=\"controller.port\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a port</option><option ng-repeat=\"port in Robot.getNumPWM()\" value=\"{{port}}\" ng-disabled=\"Robot.isPWMUsed(port)\" ng-selected=\"{{port == controller.port}}\">{{port}} {{Robot.isPWMUsed(port)? \'used\' : \'\'}}</option></select></td><td><select ng-model=\"controller.type\" class=\"form-control form-control-inline\" required=\"\"><option value=\"\" disabled=\"\">Choose a type</option><option ng-repeat=\"mc in Robot.controller.choices\" value=\"{{mc.name}}\" ng-selected=\"{{mc.name == controller.type}}\">{{mc.prettyName}}</option></select></td><td><button ng-hide=\"$first && Robot.data.controllers.length < 2\" ng-click=\"Robot.removeController(controller)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addController()\" class=\"btn btn-success pull-right\">Add Motor</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(motors.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/mc.html\'\"></div><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_03.html","<div class=\"row\" ng-controller=\"Wiz3Ctrl as step\"><form name=\"outputs\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Pneumatics</h1><ol><li>Does your robot use <abbr title=\"air pressure\">pneumatics</abbr>?<div bb-help=\"\" title=\"MPneumatics\"><p>If your robot has air cylinders/pistons the solenoids(valves) which control the air flow to to the pistons can be input in this step.</p></div><div class=\"radio\"><label><input type=\"radio\" value=\"yes\" ng-model=\"Robot.data.hasPneumatics\"> Yes!</label></div><div class=\"radio\"><label><input type=\"radio\" value=\"no\" required=\"\" ng-model=\"Robot.data.hasPneumatics\"> No.</label></div></li><li ng-if=\"Robot.data.hasPneumatics == \'yes\'\"><button ng-click=\"Robot.addSolenoid()\" class=\"btn btn-success pull-right\">Add Solenoid</button> What solenoids(pneumatic valves) are connected to your <abbr title=\"Pneumatic Control Module\">PCM</abbr>?<table class=\"table\"><thead><th>Solenoid Name</th><th>PCM Port</th><th>Solenoid Type</th><th>Action</th></thead><tbody><tr ng-repeat=\"item in Robot.data.solenoids\"><td><input ng-model=\"item.name\" type=\"text\" required=\"\" class=\"form-control form-control-inline\"></td><td><select ng-model=\"item.type\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a Solenoid type</option><option value=\"single\">Single Solenoid (Spring return)</option><option value=\"double\">Double Solenoid (Stays in place)</option></select></td><td><select ng-model=\"item.port\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a port</option><option value=\"{{port}}\" ng-repeat=\"port in Robot.getNumSolPorts()\" ng-disabled=\"Robot.isSolPortUsed(port)\" ng-selected=\"{{port === item.port}}\">{{port}} {{Robot.isSolPortUsed(port)? \'used\' : \'\'}}</option></select></td><td><button ng-hide=\"$first && Robot.data.solenoids.length < 2\" ng-click=\"Robot.removeSolenoid(item)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addSolenoid()\" class=\"btn btn-success pull-right\">Add Solenoid</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(outputs.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_04.html","<div class=\"row\" ng-controller=\"Wiz4Ctrl as step\"><form name=\"inputs\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Driver Station Inputs</h1><ol><li><button ng-click=\"Robot.addHID()\" class=\"btn btn-success pull-right\">Add</button><p>How will your robot be controlled?</p><p>This is often called the Operator Interface.</p><p>The \"DS Order\" option is the number assigned to the input by the list in the driverstation.</p><table class=\"table\"><thead><th>Name</th><th>DS Order</th><th>Type</th><th>Action</th></thead><tbody><tr ng-repeat=\"item in Robot.data.hids\"><td><input ng-model=\"item.name\" required=\"\" type=\"text\" class=\"form-control form-control-inline\"></td><td><select ng-model=\"item.port\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a port</option><option value=\"{{port}}\" ng-repeat=\"port in Robot.getNumUSBPorts()\" ng-disabled=\"Robot.isUSBPortUsed(port)\" ng-selected=\"{{port === item.port}}\">{{port}} {{Robot.isUSBPortUsed(port)? \'used\' : \'\'}}</option></select></td><td><select ng-model=\"item.type\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a type</option><option value=\"joystick\">Joystick</option><option value=\"xbox\">XBox</option><option value=\"ps\">Play Station</option></select></td><td><button ng-hide=\"$first && Robot.data.hids.length < 2\" ng-click=\"Robot.removeHID(item)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addHID()\" class=\"btn btn-success pull-right\">Add</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(inputs.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_05.html","<div class=\"row\" ng-controller=\"Wiz5Ctrl as step\"><form name=\"inputs\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Digital Inputs</h1><p>Digital inputs are most often used as limit switches.</p><ol><li>Does your robot use Digital Inputs?<div class=\"radio\"><label><input type=\"radio\" ng-model=\"Robot.data.hasDIN\" value=\"yes\"> Yes!</label></div><div class=\"radio\"><label><input type=\"radio\" ng-model=\"Robot.data.hasDIN\" value=\"no\" required=\"\"> No.</label></div></li><li ng-if=\"Robot.data.hasDIN == \'yes\'\"><button ng-click=\"Robot.addDigitalSensor()\" class=\"btn btn-success pull-right\">Add Digital Input</button> Digital Input configuration<table class=\"table\"><thead><th>Name</th><th><abbr title=\"General Purpose Digital Input and Output\">GPDIO</abbr> Port</th><th>Type</th><th>Action</th></thead><tbody><tr ng-repeat=\"item in Robot.data.sensors.digital\"><td><input ng-model=\"item.name\" required=\"\" type=\"text\" class=\"form-control form-control-inline\"></td><td><select ng-model=\"item.port\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a port</option><option value=\"{{port}}\" ng-repeat=\"port in Robot.getNumDigitalPorts()\" ng-disabled=\"Robot.isDigitalPortUsed(port)\" ng-selected=\"{{port == item.port}}\">{{port}} {{Robot.isDigitalPortUsed(port)? \'used\' : \'\'}}</option></select></td><td><select ng-model=\"item.type\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a type</option><option value=\"switch\">Switch (limit switch, push button etc)</option></select></td><td><button ng-hide=\"$first && Robot.data.sensors.digital.length < 2\" ng-click=\"Robot.removeDigitalSensor(item)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addDigitalSensor()\" class=\"btn btn-success pull-right\">Add Digital Input</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(inputs.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_06.html","<div class=\"row\" ng-controller=\"Wiz6Ctrl as step\"><form name=\"inputs\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Analog Inputs</h1><p>Analog inputs are most often used by sensors: potentiometers and gyroscopes.</p><ol><li>Does your robot use Analog Inputs?<div class=\"radio\"><label><input type=\"radio\" value=\"yes\" ng-model=\"Robot.data.hasAIN\"> Yes!</label></div><div class=\"radio\"><label><input type=\"radio\" value=\"no\" required=\"\" ng-model=\"Robot.data.hasAIN\"> No.</label></div></li><li ng-if=\"Robot.data.hasAIN == \'yes\'\"><button ng-click=\"Robot.addAnalogSensor()\" class=\"btn btn-success pull-right\">Add Analog Input</button> Analog Sensor configuration<table class=\"table\"><thead><th>Name</th><th>Analog Port</th><th>Type</th><th>Action</th></thead><tbody><tr ng-repeat=\"item in Robot.data.sensors.analog\"><td><input ng-model=\"item.name\" required=\"\" type=\"text\" class=\"form-control form-control-inline\"></td><td><select ng-model=\"item.port\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a port</option><option value=\"{{port}}\" ng-repeat=\"port in Robot.getNumAnalogPorts()\" ng-disabled=\"Robot.isAnalogPortUsed(port)\" ng-selected=\"{{port === item.port}}\">{{port}} {{Robot.isAnalogPortUsed(port)? \'used\' : \'\'}}</option></select></td><td><select ng-model=\"item.type\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a type</option><option value=\"gyro\">Gyroscope</option><option value=\"pot\">Potentiometer (standard analog input)</option></select></td><td><button ng-hide=\"$first && Robot.data.sensors.analog.length < 2\" ng-click=\"Robot.removeAnalogSensor(item)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addAnalogSensor()\" class=\"btn btn-success pull-right\">Add Analog Input</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(inputs.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_07.html","<div class=\"row\" ng-controller=\"Wiz7Ctrl as step\"><form name=\"subsystems\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Subsystems</h1><ol><li><p>To begin thinking about what the subsystems are on your robot keep these in mind:</p><ul><li>The robot is the system.</li><li>A subsystem cannot be nested in another subsystem.</li><li>A subsystem can only do one action at a time. This means that only one command can control a subsystem at a time.</li><li>To have 2 things happening at the same time, they must be in separate subsystems.</li><li>You may create as many subsystems as makes sense.</li><li>A subsystem should be a distinct part of the robot that performs a particular subset of actions.</li><li>A subsystem is a way of grouping the components(sensors, actuators, actions and state) to make coding easier.</li><li>A subsystem provides <strong>safe action methods</strong> which provide the safe interface to the underlying hardware to the rest of your robot code. Example: A lift subsystem would provide a move method that would only let the lift move if the top and bottom limit switches are not pressed.</li></ul><div class=\"hidden\"><p>A subsystem is a way of grouping the components(sensors, actuators, actions and state) to make coding easier.<ul><li><strong>Sensors:</strong> buttons, switches, potentiometers, encoders, etc.</li><li><strong>Actuators:</strong> motors &amp; solenoids</li><li><strong>Action Methods:</strong> High level actions which the subsystem can be told to perform. These are generally methods on the specific subsystem class which change the state when called.</li><li><strong>State:</strong> Variables which hold the current status of the subsystem. Generally this includes values recorded from sensors. ex: the position of an arm.</li></ul></p></div><p>Some examples of good subsystems: (Note: We will assigin components in the next step.)</p><table class=\"table\"><thead><tr><th>Name (Capitalized)</th><th>Action Methods</th><th>Components</th></tr></thead><tbody><tr><td>Drivetrain</td><td>stop, move</td><td>Victor leftFront, Victor leftRear, Victor rightFront, Victor rightRear</td></tr><tr><td>Arm</td><td>up, down, rollerOn, rollerOff, rollerReverse</td><td>Victor roller, Solenoid deploy</td></tr><tr><td>Kicker</td><td>isReady, reset, stop, kick</td><td>Victor indexer, DigitalInput limitSwitch</td></tr></tbody></table><button ng-click=\"Robot.addSubsystem()\" class=\"btn btn-success pull-right\">Add Subsystem</button><table class=\"table\"><thead><th>Name (Capitalized)</th><th>Action Methods (comma separated)</th><th></th></thead><tbody><tr ng-repeat=\"item in Robot.getInitialSubsystems()\"><td><input ng-model=\"item.name\" required=\"\" type=\"text\" class=\"form-control form-control-inline\"></td><td><tags-input ng-model=\"item.actions\" min-length=\"2\" min-tags=\"1\" enable-editing-last-tag=\"true\" placeholder=\"Add an Action Method\"></tags-input></td><td><button ng-hide=\"$first && filtered.length < 2\" ng-click=\"Robot.removeSubsystem(item)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addSubsystem()\" class=\"btn btn-success pull-right\">Add Subsystem</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(subsystems.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_08.html","<div class=\"row\" ng-controller=\"Wiz8Ctrl as step\"><form name=\"asgn\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Acutator &amp; Sensor Assiginment</h1><ol><li><p>In this step we will assign each actuator and sensor to the subsystem which will be responsible for it.</p><p>Feel free to use the progress indicator at the top to navigate to the previos step to change the subsystem configuration.</p><table class=\"table\"><thead><tr><th>Actuator Name</th><th>Actuator Type</th><th>Assigined Subsystem</th></tr></thead><tbody><tr ng-repeat=\"item in Robot.data.controllers\" ng-if=\"Robot.data.hasOtherMotors == \'yes\'\"><td>Controller: {{item.name}}</td><td>{{Robot.controller.toPretty(item.type)}}</td><td><select ng-model=\"item.subsystem\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a Subsystem</option><option value=\"{{subsys.name}}\" ng-repeat=\"subsys in Robot.getSubsystems()\" ng-selected=\"{{subsys.name === item.subsystem}}\">{{subsys.name}}</option></select></td></tr><tr ng-repeat=\"item in Robot.data.sensors.analog\" ng-if=\"Robot.data.hasAIN == \'yes\'\"><td>Analog: {{item.name}}</td><td>{{item.type}}</td><td><select ng-model=\"item.subsystem\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a Subsystem</option><option value=\"{{subsys.name}}\" ng-repeat=\"subsys in Robot.getSubsystems()\" ng-selected=\"{{subsys.name === item.subsystem}}\">{{subsys.name}}</option></select></td></tr><tr ng-repeat=\"item in Robot.data.sensors.digital\" ng-if=\"Robot.data.hasDIN == \'yes\'\"><td>Digital: {{item.name}}</td><td>{{item.type}}</td><td><select ng-model=\"item.subsystem\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a Subsystem</option><option value=\"{{subsys.name}}\" ng-repeat=\"subsys in Robot.getSubsystems()\" ng-selected=\"{{subsys.name === item.subsystem}}\">{{subsys.name}}</option></select></td></tr><tr ng-repeat=\"item in Robot.data.solenoids\" ng-if=\"Robot.data.hasPneumatics == \'yes\'\"><td>Solenoid: {{item.name}}</td><td>{{item.type}}</td><td><select ng-model=\"item.subsystem\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a Subsystem</option><option value=\"{{subsys.name}}\" ng-repeat=\"subsys in Robot.getSubsystems()\" ng-selected=\"{{subsys.name === item.subsystem}}\">{{subsys.name}}</option></select></td></tr><tr ng-if=\"Robot.data.hasDrivetrain == \'yes\'\"><td>Drivetrain</td><td>{{Robot.data.drivetrain.mcType}}</td><td><select ng-model=\"Robot.data.drivetrain.subsystem\" required=\"\" class=\"form-control form-control-inline\"><option value=\"\" disabled=\"\">Choose a Subsystem</option><option value=\"{{subsys.name}}\" ng-repeat=\"subsys in Robot.getSubsystems()\" ng-selected=\"{{subsys.name === Robot.data.drivetrain.subsystem}}\">{{subsys.name}}</option></select></td></tr></tbody></table></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(asgn.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_09.html","<div class=\"row\" ng-controller=\"Wiz9Ctrl as step\"><div class=\"col-sm-2\"><div class=\"panel panel-default\"><div class=\"panel-heading\">Current Subsystem</div><div class=\"panel-body\"><select class=\"form-control\" id=\"currentSubsystem\" ng-model=\"step.currentSubsystem\" ng-change=\"step.currentSubsysChange()\"><option ng-repeat=\"subsys in Robot.getSubsystems()\" value=\"{{subsys.name}}\" ng-selected=\"{{subsys.name === item.subsystem}}\">{{subsys.name}}</option></select></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\">Subsystem Actions</div><div class=\"panel-body\"><div class=\"list-group\"><a href=\"\" ng-repeat=\"action in Robot.getActions(step.currentSubsystem)\" class=\"list-group-item\" ng-class=\"{active: action.text == step.currentAction}\" ng-click=\"step.setActiveAction(action.text)\">{{action.text}}<span ng-if=\"!action.isDone\" class=\"fa-stack pull-right\" title=\"Action code is incomplete.\"><i class=\"fa fa-circle fa-stack-2x\" style=\"color:white;\"></i> <i class=\"fa fa-times fa-stack-1x text-danger\" style=\"line-height: 27px;\"></i></span> <span ng-if=\"action.isDone\" class=\"fa-stack pull-right\" title=\"Action code is complete!\"><i class=\"fa fa-circle fa-stack-2x\" style=\"color:white;\"></i> <i class=\"fa fa-check fa-stack-1x text-success\"></i></span></a></div><a class=\"btn btn-info\" href=\"\" ng-click=\"step.nextAction()\" ng-show=\"step.isActionComplete() && !step.isSubsystemComplete()\">Next action &raquo;</a> <a class=\"btn btn-info\" href=\"\" ng-click=\"step.nextSubsystem()\" ng-show=\"step.isSubsystemComplete() && !step.isStepComplete()\">Next subsystem &raquo;</a> <button class=\"btn btn-primary\" ng-click=\"wiz.stepComplete(step.num)\" ng-show=\"step.isStepComplete()\">Next Step &raquo;</button></div></div></div><div id=\"blocklyDiv\" class=\"col-sm-10\" style=\"height: 480px;\"></div><xml id=\"startingblocks\" style=\"display: none\"><block type=\"state_vars\" x=\"250\" y=\"0\"></block><block type=\"procedures_defreturn\" x=\"250\" y=\"100\"><mutation procname=\"{{step.currentAction}}\"></mutation></block></xml><xml id=\"toolbox\" style=\"display: none\"><category name=\"Logic\"><block type=\"controls_if\"></block><block type=\"logic_compare\"></block><block type=\"logic_operation\"></block><block type=\"logic_negate\"></block><block type=\"logic_boolean\"></block><block type=\"logic_ternary\"></block></category><category name=\"Math\"><block type=\"math_number\"></block><block type=\"math_arithmetic\"></block><block type=\"math_number_property\"></block><block type=\"math_round\"></block><block type=\"math_modulo\"></block></category><category name=\"Riolog Debug\"><block type=\"text\"></block><block type=\"text_print\"><value name=\"TEXT\"><block type=\"text\"></block></value></block><block type=\"text_join\"></block></category><category name=\"Variables\" custom=\"VARIABLE\"></category><sep></sep><category name=\"Input &amp; Sensors\"><block type=\"get_gyro\"></block><block type=\"gyro_reset\"></block><block type=\"get_digital_input_value\"></block><block type=\"get_analog_input_value\"></block><block type=\"get_joystick_axis\"></block><block type=\"get_joystick_button\"></block></category><category name=\"Motors\"><block type=\"move_motor_controller\"><value name=\"SPEED\"><shadow type=\"math_number\"><field name=\"NUM\">1</field></shadow></value></block><block type=\"stop_motor_controller\"></block><block type=\"move_drivetrain\"><value name=\"MOVE\"><shadow type=\"math_number\"><field name=\"NUM\">1</field></shadow></value><value name=\"TURN\"><shadow type=\"math_number\"><field name=\"NUM\">0</field></shadow></value></block><block type=\"stop_drivetrain\"></block><block type=\"move_with_joystick\"></block></category><category name=\"Pneumatics\"><block type=\"set_solenoid_single\"><value name=\"VALUE\"><shadow type=\"logic_boolean\" id=\"16\" x=\"245\" y=\"191\"><field name=\"BOOL\">TRUE</field></shadow></value></block><block type=\"double_solenoid_set\"></block></category><category name=\"Timing\"><block type=\"us_counter\"></block></category></xml></div><div class=\"row\"><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_10.html","<div class=\"row\" ng-controller=\"Wiz10Ctrl as step\"><form name=\"commands\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Commands</h1><ol><li><p>To begin thinking about what the commands are needed keep these in mind:</p><ul><li>A command is a single action performed by the robot.</li><li>Commands usually require at least one subsystem which they act with.</li><li>After being started, a command runs for a period of time until either it is finished performing its task or it is interrupted.</li><li>Interruptions can occur either when a command is canceled or when another command that requires the same subsystem is run.</li></ul><p></p><p><strong>What does it mean for a command to require a subsystem?</strong></p><p>When a command requires a subsystem, it claims exclusive control over that subsystem and will interrupt any other command that requires the same subsystem. This only works if all your commands properly require the subsystems that they use.</p><button ng-click=\"Robot.addCommand()\" class=\"btn btn-success pull-right\">Add</button><table class=\"table\"><thead><th>Name</th><th>Requires</th><th>Action</th></thead><tbody><tr ng-repeat=\"(idx, item) in Robot.data.commands\"><td><input ng-model=\"item.name\" required=\"\" type=\"text\" class=\"form-control form-control-inline\"></td><td><select ng-model=\"item.requires\" ng-if=\"item.type == \'cmd\'\" class=\"form-control\"><option value=\"\">None</option><option value=\"{{subsystem.name}}\" ng-repeat=\"subsystem in Robot.getSubsystems()\">{{subsystem.name}}</option></select></td><td><button ng-hide=\"$first && Robot.data.commands.length < 2\" ng-click=\"Robot.removeCommand(item)\" class=\"btn btn-danger\">Remove</button></td></tr></tbody></table><button ng-click=\"Robot.addCommand()\" class=\"btn btn-success pull-right\">Add</button></li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(commands.$valid)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_11.html","<div class=\"row\" ng-controller=\"Wiz11Ctrl as step\"><form name=\"commandCode\" novalidate=\"\" class=\"col-lg-6\" onchange=\"invalidateFutureSteps(this)\"><h1>Code</h1><ol><li>{{wiz.step}}</li><li>Blockly!</li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\" ng-disabled=\"!step.complete(true)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_12.html","<div class=\"row\" ng-controller=\"Wiz12Ctrl as step\"><form name=\"code\" novalidate=\"\" class=\"col-lg-6\"><h1>Code</h1><ol><li>{{wiz.step}}</li><li>OI</li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_13.html","<div class=\"row\" ng-controller=\"Wiz13Ctrl as step\"><form name=\"code\" novalidate=\"\" class=\"col-lg-6\"><h1>Code</h1><ol><li>{{wiz.step}}</li><li>Autonomous!</li><li><a class=\"btn btn-info\" href=\"#/wizard/{{step.num-1}}\">&laquo; Back</a> <button class=\"btn btn-primary\" href=\"#/wizard/{{step.num+1}}\" ng-click=\"wiz.stepComplete(step.num)\">Next &raquo;</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_14.html","<div class=\"row\" ng-controller=\"Wiz14Ctrl as step\"><form name=\"code\" novalidate=\"\" class=\"col-lg-6\"><h1>Code</h1><ol><li>What is your team number? <input type=\"text\" ng-model=\"Robot.data.number\" class=\"form-control\" style=\"width: auto;\"></li><li ng-show=\"!!Robot.data.number\"><button class=\"btn btn-success\" ng-click=\"step.export()\">Export Java</button></li></ol></form><div ng-include=\"\'app/wiz/steps/debug.html\'\"></div></div>");
$templateCache.put("app/wiz/steps/wiz_steps.html","<div class=\"container-fluid\"><div bb-progress=\"\" ng-model=\"$localStorage.curStep\"></div><ng-include src=\"\'app/wiz/steps/wiz_\'+wiz.step+\'.html\'\"></ng-include></div>");}]);